import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

/**
 * Reusable container component for cards with consistent styling
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {Object} [props.sx] - Additional sx styles to apply to the Card
 */
export function CardContainer({ children, sx, ...props }) {
  return (
    <Grid id="card-container" item container xs={12} {...props}>
      <Card
        variant="outlined"
        sx={{
          width: '100%',
          p: { xs: 1, sm: 2 },
          ...sx,
        }}
      >
        {children}
      </Card>
    </Grid>
  );
}
